export default class MerchantStation {
  public readonly name: string;
  public readonly originalStationId: number;
  public readonly distance: number;
  public readonly walkingTime: number;

  constructor(init: MerchantStationInitializer) {
    this.name = init.name;
    this.originalStationId = init.originalStationId;
    this.distance = init.distance;
    this.walkingTime = init.walkingTime;
  }
}

export interface MerchantStationInitializer {
  name: string;
  originalStationId: number;
  distance: number;
  walkingTime: number;
}
